import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Navigation, NavigationType, NavigationTab } from '../navigation';

import { HeadlineTitle } from '../typography';
import {
  InfoMessageWrapper,
  StyledNavigationFlex,
  StyledPageWithTable,
} from './styled';
import { TabsItems } from '../../types/Tab';
import { InfoMessage } from '../infoMessage';

export interface PageWithTableProps {
  title: string;
  tabs: (NavigationTab & TabsItems)[];
  activeTab: string;
  disclaimer?: string;
}

export const PageWithTable: FC<PageWithTableProps> = ({
  title,
  tabs,
  activeTab,
  disclaimer,
}) => {
  const { t } = useTranslation();

  const ActiveTabForm = useMemo(
    () => tabs?.find((tabForm) => tabForm.key === activeTab),
    [activeTab, tabs],
  );

  return (
    <StyledPageWithTable>
      {title && <HeadlineTitle>{title}</HeadlineTitle>}
      {disclaimer && (
        <InfoMessageWrapper>
          <InfoMessage description={disclaimer} />
        </InfoMessageWrapper>
      )}
      {tabs?.length > 1 && (
        <StyledNavigationFlex>
          <Navigation
            type={NavigationType.Tabs}
            activeTab={activeTab}
            options={tabs}
            title={t('navigation.menu')}
          />
        </StyledNavigationFlex>
      )}
      {ActiveTabForm?.component}
    </StyledPageWithTable>
  );
};
